module.exports = __webpack_public_path__ + "img/list4.8a129d05.jpg";